import React from "react";

// Tiny SVG bar chart for monthly trends. Self-scaling: renders relative to
// its own max value (not to siblings' max), so different metrics don't
// distort each other. Hover any bar for a tooltip with the exact number.
//
// data: [{ month: "YYYY-MM", count: number }, ...]
const SparkBars = ({
    data,
    height = 60,
    barColor = "#0d6efd",
    emptyColor = "#dee2e6",
}) => {
    if (!data || data.length === 0) {
        return <div style={{ height, color: "#999", fontSize: 12 }}>No data</div>;
    }

    const max = Math.max(1, ...data.map((d) => d.count));
    const barGap = 2;
    const innerHeight = height - 18; // leave room for x-axis labels

    return (
        <div>
            <svg
                width="100%"
                height={height}
                viewBox={`0 0 ${data.length * 10} ${height}`}
                preserveAspectRatio="none"
                role="img"
                aria-label="12-month trend"
            >
                {data.map((d, i) => {
                    const ratio = d.count / max;
                    const barH = ratio * innerHeight;
                    const x = i * 10 + barGap / 2;
                    const y = innerHeight - barH;
                    const w = 10 - barGap;
                    return (
                        <g key={d.month}>
                            <rect
                                x={x}
                                y={y}
                                width={w}
                                height={Math.max(barH, 1)}
                                fill={d.count === 0 ? emptyColor : barColor}
                                rx={1}
                            >
                                <title>{`${d.month}: ${d.count}`}</title>
                            </rect>
                        </g>
                    );
                })}
            </svg>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 10,
                    color: "#888",
                    marginTop: 2,
                }}
            >
                <span>{shortMonth(data[0].month)}</span>
                <span>{shortMonth(data[data.length - 1].month)}</span>
            </div>
        </div>
    );
};

// "2026-01" → "Jan '26"
function shortMonth(yyyymm) {
    const [y, m] = yyyymm.split("-");
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${months[parseInt(m, 10) - 1]} '${y.slice(-2)}`;
}

export default SparkBars;
